export const accessed_ebook = function (ebook_id) {
  return axios({
    url: `/api/v1/student/ebook/${ebook_id}`,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => {
    /*TODO implementar donwload vindo da api*/
    // const url = window.URL.createObjectURL(new Blob([response.data]));
    // const link = document.createElement('a');
    // link.href = url;
    // link.setAttribute('download', 'file.pdf'); //or any other extension
    // document.body.appendChild(link);
    // link.click();
  });
}
